module.exports = __webpack_public_path__ + "static/media/20.975c0803.jpg";